import { useState } from "react";
import { faqs } from "@/mocks/faqs";

export default function Faq() {
  const [openId, setOpenId] = useState<string | null>(faqs[0].id);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-block rounded-full bg-secondary-100 px-4 py-1 text-sm font-medium text-secondary-900">
            常见问答
          </span>
          <h2 className="mt-4 text-2xl font-black text-foreground-950 md:text-4xl">
            大家常问的问题
          </h2>
          <p className="mt-3 text-sm leading-7 text-foreground-600 md:text-base">
            从收藏同步到验证码收不到，这些问题帮你一次搞清楚，省去来回折腾。
          </p>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((f) => {
            const open = openId === f.id;
            return (
              <div
                key={f.id}
                className={`overflow-hidden rounded-2xl border transition-colors ${
                  open ? "border-primary-200 bg-background-50" : "border-background-200 bg-background-50"
                }`}
              >
                <button
                  onClick={() => setOpenId(open ? null : f.id)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="flex items-center gap-3 text-sm font-bold text-foreground-900 md:text-base">
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm ${
                        open ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                      }`}
                    >
                      {open ? <i className="ri-question-line" /> : <i className="ri-add-line" />}
                    </span>
                    {f.question}
                  </span>
                  <i
                    className={`ri-arrow-down-s-line text-xl text-foreground-600 transition-transform ${
                      open ? "rotate-180" : ""
                    }`}
                  />
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm leading-7 text-foreground-600">
                      {f.answer}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}